import CheckboxComponent from '../../../../components/CheckboxComponent';
import SelectorEngine from '../../../../utils/dom/selector-engine';
import EventHandler from '../../../../utils/dom/event-handler';

const CHANGE_EVENT = 'change';
const EXCLUSIVE_OPTION_ID = 'always_free';

class PaymentOptions extends CheckboxComponent {
	constructor(containerElement, config) {
		super(containerElement, config);
		this.exclusiveOptionId =
			config.data.options?.find((option) => option.isExclusive)?.id || EXCLUSIVE_OPTION_ID;

		setTimeout(() => {
			this.applyPaymentOptionsLayout();
			this.updateExclusiveOptionStates();
		}, 0);
	}

	markup(value, data, titleMarkup) {
		const spacingClass = data?.spacingClass || 'u-mb-5';

		return `
			<fieldset>
				<legend>${titleMarkup}</legend>
				${
					data?.instructionText
						? `<p class="lta-text-input__label u-text-grey-lta lta-heading-subtitle">${data?.instructionText}</p>`
						: ''
				}
				<div class="lta-form-check-group lta-form-check-group--payment-options ${spacingClass}">
					<div id="lta-radio-checkbox-error" class="lta-form-check--error u-mb-1 u-hidden">${data.errorMessage}</div>
					<div class="lta-form-check--options">
						${data.options
							.map((option) => {
								const checkboxId = `${data.id}_${option.id}`;
								const orSeparatorMarkup = option.hasOrSeparator
									? `<p class="lta-form-check--or-separator u-body2 u-text-grey-lta u-mb-1 u-mt-2">Or</p>`
									: '';

								return `
							${orSeparatorMarkup}
							<div class="lta-form-check u-mb-1">
								<input class="lta-form-check-input js-option-checkbox" type="checkbox" id="${checkboxId}" value="${option.id}" ${
									this.data.value?.includes(option.id) ? 'checked' : ''
								} />
								<label class="lta-form-check-label u-body1" for="${checkboxId}">${option.label}</label>
							</div>
						`;
							})
							.join('')}
					</div>
				</div>
			</fieldset>
		`;
	}

	afterRender() {
		super.afterRender();
		this.applyPaymentOptionsLayout();
	}

	applyPaymentOptionsLayout() {
		const checkOptions = SelectorEngine.find('.lta-form-check-group--payment-options .lta-form-check', this.containerEl);

		for (const option of checkOptions) {
			option.style.padding = '0';
			option.style.marginLeft = '0';
		}
	}

	initEventListeners() {
		const checkboxes = SelectorEngine.find('.js-option-checkbox', this.containerEl);

		for (const checkbox of checkboxes) {
			EventHandler.on(checkbox, CHANGE_EVENT, (event) => {
				this.handleExclusiveOptions(event.target);
				this.handleCheckboxClick(true);
			});
		}
	}

	getExclusiveCheckbox() {
		return SelectorEngine.find('.js-option-checkbox', this.containerEl).find(
			(checkbox) => checkbox.value === this.exclusiveOptionId
		);
	}

	getStandardCheckboxes() {
		return SelectorEngine.find('.js-option-checkbox', this.containerEl).filter(
			(checkbox) => checkbox.value !== this.exclusiveOptionId
		);
	}

	handleExclusiveOptions(changedCheckbox) {
		const exclusiveCheckbox = this.getExclusiveCheckbox();

		if (!exclusiveCheckbox) {
			return;
		}

		const standardCheckboxes = this.getStandardCheckboxes();
		const isExclusive = changedCheckbox.value === this.exclusiveOptionId;

		if (isExclusive && changedCheckbox.checked) {
			for (const checkbox of standardCheckboxes) {
				checkbox.checked = false;
			}
		} else if (!isExclusive && changedCheckbox.checked) {
			exclusiveCheckbox.checked = false;
		}

		this.updateExclusiveOptionStates();
	}

	updateExclusiveOptionStates() {
		const exclusiveCheckbox = this.getExclusiveCheckbox();

		if (!exclusiveCheckbox) {
			return;
		}

		const standardCheckboxes = this.getStandardCheckboxes();
		const isExclusiveSelected = exclusiveCheckbox.checked;
		const hasStandardSelection = standardCheckboxes.some((checkbox) => checkbox.checked);

		exclusiveCheckbox.disabled = hasStandardSelection;

		for (const checkbox of standardCheckboxes) {
			checkbox.disabled = isExclusiveSelected;
		}
	}

	updateValue(checkedCheckboxes = []) {
		const hasExclusiveSelection = checkedCheckboxes.some(
			(checkbox) => checkbox.value === this.exclusiveOptionId
		);
		const hasStandardSelection = checkedCheckboxes.some(
			(checkbox) => checkbox.value !== this.exclusiveOptionId
		);

		if (hasExclusiveSelection && hasStandardSelection) {
			const exclusiveCheckbox = this.getExclusiveCheckbox();
			checkedCheckboxes = exclusiveCheckbox?.checked
				? checkedCheckboxes.filter((checkbox) => checkbox.value === this.exclusiveOptionId)
				: checkedCheckboxes.filter((checkbox) => checkbox.value !== this.exclusiveOptionId);
		}

		super.updateValue(checkedCheckboxes);
	}
}

export default PaymentOptions;
